import { observable, action, runInAction, toJS, keys } from "mobx";

import * as API from "../../api/invite";
import { getLabel } from "@weapp/utils";
import { Dialog } from "@weapp/ui";
const { message } = Dialog;

export class InviteDialogStore {
  @observable uuid: string = "";
  @observable forms: any = [];
  @observable inviteResults: any = [];
  @observable inviteLoading: boolean = false;
  @observable accountTypes: any[] = [];
  @observable personalStatus: any[] = [];
  @action
  init = () => {
    this.forms = []

    // 获取入职状态选项数据
    API.qryPersonelStatus().then((result: any) => {
      const { data } = result;
      runInAction(() => {
        if (data && data.length) {
          this.personalStatus = data.map((d: any) => {
            return {
              id: `${d.codeId}`,
              content: `${d.name}`
            }
          });
          const defaultPersonalStatus = this.personalStatus[0].id;

          runInAction(() => {
            this.accountTypes = ["2","3","0","1"];
            const info = this.getAccountTypeAndTips(this.accountTypes);
            let tempData = [];
            for (let i = 0; i < 5; i++) {
              tempData.push({
                invitee: "",
                accountType: info.defaultVal,
                contact: "",
                personalStatus: defaultPersonalStatus,
                inviteNo: i + 1,
              });
            }
            this.forms = tempData;
            return;
          });

          // API.qryLoginType().then((result: any) => {
          //   if (result && result.code === 200) {
          //     let { data = {} } = result;
          //     if (!data) {
          //       data = "2,3"; // 默认给手机号和邮箱
          //     }
          //     runInAction(() => {
          //       this.accountTypes = data.split(",");
          //       const info = this.getAccountTypeAndTips(data.split(","));
          //       let tempData = [];
          //       for (let i = 0; i < 5; i++) {
          //         tempData.push({
          //           invitee: "",
          //           accountType: info.defaultVal,
          //           contact: "",
          //           personalStatus: defaultPersonalStatus,
          //           inviteNo: i + 1,
          //         });
          //       }
          //       this.forms = tempData;
          //       return;
          //     });
          //   }
          // });

        }
      });
    });
  };

  getAccountOpts = () => {
    let options: any = [];
    let opts: any = {
      "0": {
        id: "0",
        content: getLabel("101250", "登录名"),
        order: 3 // 账号显示优先级   手机号 > 邮箱 > 登录名 > 工号
      },
      "1": {
        id: "1",
        content: getLabel("101251", "工号"),
        order: 4
      },
      "2": {
        id: "2",
        content: getLabel("101252", "手机号"),

        order: 1
      },
      "3": {
        id: "3",
        content: getLabel("33550", "邮箱"),
        order: 2
      }
    }

    this.accountTypes.forEach((at: any) => {
      options.push(opts[at]);
    });

    options.sort(function (a: any, b: any) {
      return a.order > b.order ? 1 : a.order < b.order ? -1 : 0
    });

    return options;
  }

  getAccountTypeAndTips = (accountTypes: any) => {
    let labelTips: string = '';
    let defaultVal: string = '';


    if (accountTypes.includes("1")) {
      labelTips = getLabel('157598', '请输入工号');
      defaultVal = "1";
    }

    if (accountTypes.includes("0")) {
      labelTips = getLabel('157597', '请输入登录名');
      defaultVal = "0";
    }

    if (accountTypes.includes("3")) {
      labelTips = getLabel('157600', '请输入邀请邮箱');
      defaultVal = "3";
    }

    if (accountTypes.includes("2")) {
      labelTips = getLabel('157599', '请输入邀请手机号');
      defaultVal = "2";
    }

    return {
      labelTips,
      defaultVal
    }

  }


  @action
  updateForms = (params: any) => {
    this.forms.forEach((item: any) => {
      if (item.inviteNo === params.inviteNo) {
        item.invitee = params.invitee;
        item.contact = params.contact;
        item.accountType = params.accountType;
        item.personalStatus = params.personalStatus;
        item.areaCode = params.areaCode;
      }
    });
  };

  @action
  reset = () => {
    this.forms = [];
    this.inviteResults = [];
    this.init();
  };
  @action
  sendInvitees = (inviteParams: any, callback: any, failCallback: any) => {
    this.inviteLoading = true;
    API.saveInvitees(inviteParams).then((data: any) => {

      if (data && data.code !== 200) {
        message({
          type: "error",
          content: data.msg
        });
        runInAction(() => {
          this.inviteLoading = false;
          failCallback(data);
        });
        return;
      }

      if (data && data.inviteInfos) {
        runInAction(() => {
          this.inviteResults = data.inviteInfos;
          this.inviteLoading = false;
          if (callback) {
            const avatars = data?.empAvatar;
            let empInvitesList = [] as any;
            if (data?.empInvites) {
              for (let val of data?.empInvites) {
                const defaultAvatar = {userId: Object.keys(val)[0], name: Object.values(val)[0], appPreviewPath: "/api/app/file/preview?type=redirect&fileId=", previewPath: 
                "/api/file/preview?type=redirect&fileId="};

                const avatar = avatars[Object.keys(val)[0]] || defaultAvatar;

                empInvitesList.push({ id: Object.keys(val)[0], content: Object.values(val)[0], avatar })
              }
            }
            callback(data.inviteInfos, empInvitesList);
          }
        });
      }
    }).catch((error) => {
      this.inviteLoading = false;
      console.log(error);
    });
  };

  @action
  getUUID = (callback: (data: any) => void) => {
    API.getUuid()
      .then((data) => {
        if (callback) callback(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  @action
  checkUserMobileBind = (callback?: Function) => {

    if (window.TEAMS?.deploy === 'private') {//安装环境放开校验-暂时屏蔽
      callback && callback(true);
      return
    }
    API.checkUserInviteMobileBind().then((result: any) => {
      runInAction(() => {
        callback && callback(result.data);
      });
    }).catch((error) => {
      console.log(error);
    });
  }

}
const instance = new InviteDialogStore();

export default instance;
